 <script>
     export let text;
     export let languages;
 </script>

{#if $languages === 'hu'}
 {#if text === 'midterm'}Jegy: É{/if}
 {#if text === 'exam'}Jegy: V{/if}
{/if}
{#if $languages === 'en'}
 {#if text === 'midterm'}Midterm{/if}
 {#if text === 'exam'}Exam{/if}
{/if}
